import * as React from "react"
import type { SVGProps } from "react"
const SvgGripDots = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9 20.47q-.66 0-1.14-.47a1.6 1.6 0 0 1-.47-1.14q0-.68.47-1.14A1.6 1.6 0 0 1 9 17.24q.66 0 1.14.48.48.47.48 1.14T10.14 20a1.6 1.6 0 0 1-1.14.47m6 0q-.66 0-1.14-.47a1.6 1.6 0 0 1-.47-1.14q0-.68.47-1.14a1.6 1.6 0 0 1 1.14-.48q.66 0 1.14.48.48.47.48 1.14T16.14 20a1.6 1.6 0 0 1-1.14.47m-6-6q-.66 0-1.14-.47a1.6 1.6 0 0 1-.47-1.14q0-.67.47-1.14A1.6 1.6 0 0 1 9 11.24q.66 0 1.14.48.48.47.48 1.14T10.14 14a1.6 1.6 0 0 1-1.14.47m6 0q-.66 0-1.14-.47a1.6 1.6 0 0 1-.47-1.14q0-.67.47-1.14a1.6 1.6 0 0 1 1.14-.48q.66 0 1.14.48.48.47.48 1.14T16.14 14a1.6 1.6 0 0 1-1.14.47m-6-6q-.66 0-1.14-.47a1.6 1.6 0 0 1-.47-1.14q0-.67.47-1.14A1.6 1.6 0 0 1 9 5.24q.66 0 1.14.48.48.47.48 1.14T10.14 8A1.6 1.6 0 0 1 9 8.47m6 0q-.66 0-1.14-.47a1.6 1.6 0 0 1-.47-1.14q0-.67.47-1.14A1.6 1.6 0 0 1 15 5.24q.66 0 1.14.48.48.47.48 1.14T16.14 8a1.6 1.6 0 0 1-1.14.47" />
  </svg>
)
export default SvgGripDots
